import { render, staticRenderFns } from "./UpdatePwdDialog.vue?vue&type=template&id=ece1ff6c&scoped=true&"
import script from "./UpdatePwdDialog.vue?vue&type=script&lang=js&"
export * from "./UpdatePwdDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePwdDialog.vue?vue&type=style&index=0&id=ece1ff6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece1ff6c",
  null
  
)

export default component.exports